import Energy from "@hydrologiq/shared/monitoring/figures/Energy"
import { EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface EnergyGeneratedFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function EnergyGeneratedFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("energy_flow") }: EnergyGeneratedFigureProps) {
  const hasValue = data?.value !== undefined && data?.value !== null
  const placeholder = isPlaceholder ?? (!data?.available || !hasValue)
  const quantity = data?.value ?? 0
  const previousQuantity = data?.previousValue ?? (data?.metadata as any)?.previousValue ?? 0

  // Map unit string to EnergyUnit enum
  const unitMap: Record<string, EnergyUnit> = {
    kg: EnergyUnit.kg,
    kwh: EnergyUnit.KWH,
    wh: EnergyUnit.WH,
  }
  const desiredUnit = unitMap[data?.unit?.toLowerCase() ?? "kwh"] ?? EnergyUnit.KWH

  // Determine period from metadata or default to latest
  const period = data?.metadata?.period ?? "today"

  return (
    <Energy
      quantity={quantity}
      desiredUnit={desiredUnit}
      period={period}
      previousQuantity={previousQuantity}
      heading={data?.label}
      loading={loading}
      error={error}
      isPlaceholder={placeholder}
      compact={compact}
    />
  )
}

export default EnergyGeneratedFigure
